import { Link } from "react-router-dom";
import { Truck } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="border-t border-xd-border bg-xd-bg mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <LogoMark to={null} />
          <p className="mt-4 text-sm text-xd-muted">Everything hotshot. One platform.</p>
          <p className="mt-3 text-xs text-xd-dim leading-relaxed">
            XD FREIGHT LLC · USDOT 3994079 · MC 1499189<br/>Active property carrier<br/>3722 E Lockwood Dr, Houston, TX 77026
          </p>
        </div>
        <FooterCol title="Platform" links={[["Find Loads","/find-loads"],["Ship With XD","/ship"],["For Carriers","/for-carriers"],["Pricing","/pricing"]]} />
        <FooterCol title="Products" links={[["XD Marketplace","/marketplace"],["XD Funding","/funding"],["XD Academy","/academy"],["XD Money","/dashboard/money"]]} />
        <FooterCol title="Company" links={[["About XD","/about"],["Join XD","/register"],["Login","/login"]]} />
      </div>
      <div className="border-t border-xd-border">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-xd-dim">
          <span>© {new Date().getFullYear()} XD FREIGHT LLC. All rights reserved.</span>
          <span>XD holds property carrier authority only. Brokerage features coming soon, pending authority.</span>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-white mb-4">{title}</h4>
      <ul className="space-y-2.5">
        {links.map(([l, to]) => (
          <li key={to}><Link to={to} className="text-sm text-xd-muted hover:text-xd-orange transition-colors">{l}</Link></li>
        ))}
      </ul>
    </div>
  );
}
